define('services/common/ajax/hiCloudFolder',['app'], function (app) {
    app.factory('HiCloudFolder', ['$q','auiAjaxWithError',function ($q,auiAjaxWithError) {

        return {
            queryAgentAppList: auiAjaxWithError.curryOld('HiCloudFolder.Agent.queryAgentAppList')
        }
    }]);
});
